"use client"

import { useEffect, useRef } from "react"

export const useHistoryDismiss = (open: boolean, onClose: () => void) => {
  const onCloseRef = useRef(onClose)
  const heldRef = useRef(false)
  const openedAtRef = useRef("")
  const pendingReleaseRef = useRef<AbortController>(null)
  const pendingTraversalRef = useRef(false)
  onCloseRef.current = onClose

  useEffect(() => {
    pendingReleaseRef.current?.abort()
    const pendingRelease = new AbortController()
    pendingReleaseRef.current = pendingRelease
    const release = () => {
      if (!heldRef.current || window.location.href !== openedAtRef.current) return
      heldRef.current = false
      pendingTraversalRef.current = true
      window.history.back()
    }
    const finishRelease = () => {
      pendingTraversalRef.current = false
      if (!open || window.location.href !== openedAtRef.current) return
      heldRef.current = true
      window.history.pushState(null, "", openedAtRef.current)
    }
    if (!open) {
      release()
      if (!pendingTraversalRef.current) return
      window.addEventListener("popstate", finishRelease, { once: true })
      return () => window.removeEventListener("popstate", finishRelease)
    }
    if (!heldRef.current && !pendingTraversalRef.current) {
      openedAtRef.current = window.location.href
      heldRef.current = true
      window.history.pushState(null, "", openedAtRef.current)
    }
    const onPopState = () => {
      if (pendingTraversalRef.current) {
        finishRelease()
        return
      }
      heldRef.current = false
      onCloseRef.current()
    }
    window.addEventListener("popstate", onPopState)
    return () => {
      window.removeEventListener("popstate", onPopState)
      queueMicrotask(() => {
        if (!pendingRelease.signal.aborted) release()
      })
    }
  }, [open])
}
